import styled from 'styled-components';

const top = 0;
const left = 0;
export const Container = styled.div`
  background: #fff;
  position: absolute;
  top: 25px;
  left: ${({ minimized }) => (minimized ? '92px' : '205px')};
  z-index: 10;
  width: 320px; 
  height: 540px;

  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.25);
`;

export const BtnManagerUser = styled.button`
  position: absolute;
  width: 226px;
  height: 38px;
  top: ${top + 175}px;
  left: ${left + 47}px;
  background: #fff;
  border: 1px solid #3e81f7;
  box-sizing: border-box;
  border-radius: 4px;

  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;

  text-align: center;

  color: #3e81f7;
  outline: inherit;

  :hover {
    background-color: #e2e2e2;
  }
`;

export const Line = styled.div`
  position: absolute;
  width: 280px;
  height: 1px;
  left: ${left + 20}px;
  top: ${props => props.height + top}px;
  background: #ffffff;
  border: 1px solid #cbcbcb;
  box-sizing: border-box;
  border-radius: 4px;
`;

export const BtnExit = styled.button`
  position: absolute;
  width: 228px;
  height: 38px;
  top: ${top + 480}px;
  left: ${left + 47}px;

  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;

  text-align: center;

  color: #565656;

  border: 1px solid #565656;
  box-sizing: border-box;
  border-radius: 4px;

  background: none;
  font: inherit;
  outline: inherit;

  :hover {
    background-color: #e2e2e2;
  }
`;

export const UserName = styled.p`
  position: absolute;
  width: 150px;
  height: 30px;
  left: ${left + 82}px;
  top: ${top + 120}px;
  margin: 0;
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 22px;
  text-align: center;
  color: #000000;
`;

export const Subtitle = styled.p`
  position: absolute;
  width: 152px;
  height: 20px;
  left: ${left + 82}px;
  top: ${top + 142}px;

  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  color: #a1a1a1;
`;

export const UserImage = styled.div`
  position: absolute;
  width: 80px;
  height: 80px;
  left: ${left + 114.7}px;
  top: ${top + 20}px;
  background: url(${({ src }) => src}) no-repeat;
  background-size: cover;
  border-radius: 50%;
`;


export const CompanyList = styled.div`
  display: flex;
  padding-bottom: 20px;
  width: 100%;
  cursor: ${props => (props.isDisabled ? 'default' : 'pointer')};
  :hover {
    background-color: #e2e2e2;
  }

  div{
    width: 70%
  }
  
  b{
    font-family: 'Roboto', sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 22px;
      
    text-align: center;
    color: ${props => (props.isDisabled ? '#ff7700' : '')};
  }

  span{
    font-family: 'Roboto', sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
      
    color: #A1A1A1;
  }
`;

export const Logo = styled.img`
  height: 40px;
  width: 45px;
  margin-right: 12px;
  src: url(${props => props.src}) no-repeat center;
  background-size: cover;
  border-radius: 50%;
`;

export const ContentListCompanies = styled.div`
  position: relative;
  left: ${left + 20}px;
  top: ${230 + top}px;
  padding: 20px 20px 20px 30px;
  
  > div{
    display: flex;
    flex-direction: column;
    width: 85%;
  
    max-height: 180px;
    overflow-y: auto;
  }
`;

export const Loader = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  align-items: center;
  justify-content: center;
  padding: 40px;
`;
